<template>
	<div class="category-chart fleCol alit justc">
		<!-- <div class="category-chart__desc">柱状图展示各分类交易数量，当前先使用静态模拟数据。</div> -->
		<div id="categoryTradeStatsChart" class="category-chart__canvas"></div>
	</div>
</template>

<script>
	import * as echarts from 'echarts'

	export default {
		data() {
			return {
				myChart: null,
				resizeHandler: null,
				mockData: [{
					name: '毛肚',
					value: 21325
				}, {
					name: '鸭肠',
					value: 20885
				}, {
					name: '火锅底料',
					value: 35642
				}, {
					name: '油类',
					value: 5648
				}, {
					name: '原材料',
					value: 203652
				}, {
					name: '农副食材',
					value: 105221
				}, {
					name: '禽畜食材',
					value: 172311
				}, {
					name: '海鲜水产',
					value: 8456
				}]
			}
		},
		mounted() {
			this.initChart()
		},
		beforeDestroy() {
			if (this.resizeHandler) {
				window.removeEventListener('resize', this.resizeHandler)
			}
			if (this.myChart) {
				this.myChart.dispose()
				this.myChart = null
			}
		},
		methods: {
			initChart() {
				const chartDom = document.getElementById('categoryTradeStatsChart')
				if (!chartDom) {
					return
				}
				this.myChart = echarts.init(chartDom, 'purple-passion')
				this.resizeHandler = () => {
					if (this.myChart) {
						this.myChart.resize()
					}
				}
				window.addEventListener('resize', this.resizeHandler)
				this.myChart.setOption({
					backgroundColor: 'transparent',
					grid: {
						left: '0%',
						right: '4%',
						bottom: '1%',
						top: '10%',
						containLabel: true
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						},
						formatter: params => {
							const item = params[0]
							return `${item.name}<br/>交易数量：${item.value} 件`
						}
					},
					xAxis: {
						type: 'category',
						data: this.mockData.map(item => item.name),
						axisTick: {
							show: false
						},
						axisLine: {
							lineStyle: {
								color: 'rgba(123, 197, 255, 0.45)'
							}
						},
						axisLabel: {
							color: '#d8eeff',
							fontSize: 13,
							interval: 0,
							// rotate: 18
						}
					},
					yAxis: {
						type: 'value',
						name: '交易数量',
						nameTextStyle: {
							color: '#9ed9ff'
						},
						splitLine: {
							lineStyle: {
								color: 'rgba(123, 197, 255, 0.12)'
							}
						},
						axisLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							color: '#c7e6ff'
						}
					},
					series: [{
						name: '交易数量',
						type: 'bar',
						barWidth: 24,
						data: this.mockData.map(item => item.value),
						itemStyle: {
							borderRadius: [10, 10, 0, 0],
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: '#59f0ff'
							}, {
								offset: 1,
								color: '#0c6cff'
							}])
						},
						emphasis: {
							itemStyle: {
								color: '#7cf7d4'
							}
						},
						label: {
							show: true,
							position: 'top',
							color: '#ffffff',
							formatter: '{c}'
						}
					}]
				})
			}
		}
	}
</script>

<style scoped>
	.category-chart {
		height: 100%;
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.category-chart__desc {
		margin-bottom: 20px;
		font-size: 15px;
		color: rgba(214, 237, 255, 0.78);
		text-align: center;
	}

	.category-chart__canvas {
		width: 100%;
		height: 46vh;
		min-height: 420px;
	}
</style>
